import {ThemeIcon} from "@mantine/core";
import {ListSource} from "../../../../types";
import IconListCheck from "../../../../assets/list-check.svg?react";
import IconArrowDownRight from "../../../../assets/arrow-down-right.svg?react";
import {t} from "i18next";
import {RelatedGroup, RelatedItem} from "../../../../components/related-list";

type RelatedToolsListProps = {
    results: ListSource[];
    showDebugIndicators?: boolean;
};

export const RelatedToolsList = ({results, showDebugIndicators}: RelatedToolsListProps) => {
    return (
        <RelatedGroup
            icon={<IconListCheck style={{width: "1.2rem", height: "1.2rem"}} />}
            title={t("contextSidebar.ToolsHeading")}
            items={results}
            keyExtractor={(r) => r.topicId}
            emptyText={t("contextSidebar.noRelatedTemplates")}
            renderItem={(result) => (
                <RelatedItem
                    title={result.topicTitle}
                    description={result.description}
                    href={result.url || "#"}
                    leadingIcon={
                        <ThemeIcon variant="subtle" size="sm" color="dark">
                            <IconArrowDownRight width={20} />
                        </ThemeIcon>
                    }
                    linkProps={{target: "_blank", rel: "noopener noreferrer"}}
                    debugScore={showDebugIndicators ? result.score : undefined}
                />
            )}
        />
    );
};
